<template>
  <div class="c-product-card-discount-rate">
    <span>{{ discountRate }}%OFF</span>
  </div>
</template>

<script>
export default {
  name: 'ComponentProductDiscountRate',
  props: {
    discountRate: { type: Number, default: 0 },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/reset-new';
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-product-card-discount-rate {
  background-color: variables.$color-red;
  border-radius: 50px;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  padding: 4px 8px;
  height: fit-content;
  width: fit-content;

  @include mixins.screen-mobile {
    font-size: 8px;
    padding: 2px 6px;
  }
}
</style>
